/**
 * @module websocket.event.handlers.passengers.passenger-deleted
 */

export default function handlePassengerDeleted(payload) {
  console.log('HandlePassengerDeleted', payload)
}
